<script>
	export default {
		functional: true,
		props: {
			name: {
				type: String,
				required: true
			}
		},
		render(createElement, { props, data }) {
			let svgHTML = '';
			try {
				svgHTML = require('src/assets/graphics/icons/' + props.name + '.svg?inline-svg');
			}
			catch (e) {
				console.warn(`Unable to load "icon-${props.name}.svg" icon. Verify it exists in the icons directory.`, e);
			}
			return createElement(svgHTML.default, data);
		}
	};
</script>